import { z } from 'zod'

export const SimulationObstacleSchema = z.object({
  id: z.string().min(1),
  label: z.string().min(1),
  preset: z.enum(['small', 'medium', 'large', 'custom']),
  size: z.object({
    x: z.number().positive(),
    y: z.number().positive(),
    z: z.number().positive(),
  }),
  massKg: z.number().positive(),
  position: z.object({
    x: z.number(),
    y: z.number(),
    z: z.number(),
  }),
})

export type SimulationObstacle = z.infer<typeof SimulationObstacleSchema>
export type SimulationObstaclePreset = SimulationObstacle['preset']

export const OBSTACLE_PRESETS = {
  small: {
    label: '소',
    sizeCm: { x: 5, y: 5, z: 5 },
    massG: 50,
  },
  medium: {
    label: '중',
    sizeCm: { x: 10, y: 8, z: 10 },
    massG: 250,
  },
  large: {
    label: '대',
    sizeCm: { x: 18, y: 12, z: 18 },
    massG: 1000,
  },
} as const

export type ObstacleDraft = {
  preset: SimulationObstaclePreset
  sizeCm: { x: number; y: number; z: number }
  massG: number
}

